export type GateModuleBenefit = Readonly<{
  description: string;
  id: string;
  title: string;
}>;

export const SMART_PRICING_GATE_COPY = {
  isExcludedFromTrial: true,
  title: "Upgrade to find your perfect price point",
  upgradeBenefits: [
    {
      description:
        "Run price tests on any product or product collection. See profit per visitor on every variant and let the data choose the right price.",
      id: "product-prices",
      title: "Test the price of every product",
    },
    {
      description:
        "Test pricing on subscription plans, frequency options, and discounts. Find the price that earns more profit and keeps customers longer.",
      id: "subscription-prices",
      title: "Test subscription prices that build LTV",
    },
    {
      description:
        "Test prices in any Shopify-supported currency. Optimize for each market on its own without affecting the others.",
      id: "currency-prices",
      title: "Test currency-specific pricing for every market",
    },
  ],
} as const satisfies Readonly<{
  isExcludedFromTrial: boolean;
  title: string;
  upgradeBenefits: readonly GateModuleBenefit[];
}>;

export const SMART_PRICING_GATE_FEATURES: readonly string[] =
  SMART_PRICING_GATE_COPY.upgradeBenefits.map(({ title }) => title);
